import { render, staticRenderFns } from "./preNews.vue?vue&type=template&id=2df616f2&scoped=true&"
import script from "./preNews.vue?vue&type=script&lang=js&"
export * from "./preNews.vue?vue&type=script&lang=js&"
import style0 from "./preNews.vue?vue&type=style&index=0&id=2df616f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df616f2",
  null
  
)

export default component.exports